import images from '../assets/Sources/index.js'

export const sources = [
  {
    id: 'google',
    name: 'Google Ads',
    image: images.google,
  },
  {
    id: 'facebook',
    name: 'Facebook Ads',
    image: images.facebook,
  },
  {
    id: 'linkedin',
    name: 'Linkedin Ads',
    image: images.linkedin,
  },
  {
    id: 'x',
    name: 'X Ads',
    image: images.x,
  },
  {
    id: 'tiktok',
    name: 'Tiktok Ads',
    image: images.tiktok,
  },
  {
    id: 'mailchimp',
    name: 'Custom Campaign',
    image: images.emailCampaign,
  },
  {
    id: 'microsoft',
    name: 'Microsoft Ads',
    image: images.microsoft,
  },
]

export const sourceConverter = (s) => {
  try {
    return sources.filter((t) => t.id === s.toLowerCase())[0].name
  } catch (error) {
    return s
  }
}
